var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#0F538D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-file-spreadsheet-icon lucide-file-spreadsheet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2v4a2 2 0 0 0 2 2h4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13h2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportActive);
export default __webpack_public_path__ + "static/media/reportActive.3a28eb0236a20f9f7027d76d8b9835d0.svg";
export { ForwardRef as ReactComponent };